import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatNumber } from '../../common/helpers';
import useFetch from '../../common/useFetch';
import PrizeSchemeService from '../../domain/PrizeSchemeService';
import gs from '../../styles/style';
import { UserContext } from '../Auth/UserProvider';
import { Pager, SearchInput, TableLoader, useDataframe } from '../Common/Dataframe';
import DateTime from '../Common/DateTime';
import { ConfirmationModal, useModal } from '../Common/Modal';
var PrizeSchemeOverview = function () {
    var t = useTranslation()[0];
    var user = useContext(UserContext).user;
    var dataframe = useDataframe(PrizeSchemeService.getPrizeSchemes, {
        perPage: 10
    });
    var _a = useFetch(PrizeSchemeService.deletePrizeScheme, {
        onSuccess: function () {
            dataframe.reload();
        }
    }), deletePrizeScheme = _a.post, deleting = _a.loading;
    var deleteModal = useModal({
        onClose: function (prizeScheme) {
            if (prizeScheme) {
                deletePrizeScheme(prizeScheme);
            }
        }
    });
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') }, t('prize_schemes')),
            user.isManager() && React.createElement("div", { className: gs('section-options') },
                React.createElement(Link, { to: "/prize-schemes/add", className: gs('btn', 'btn-primary') }, t('add_prize_scheme')))),
        React.createElement("div", { className: gs('w-50') },
            React.createElement(SearchInput, { dataframe: dataframe })),
        React.createElement("table", { className: gs('table-overview', 'mt-4', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '30%' } }, t('prize_scheme')),
                    React.createElement("th", { style: { width: '15%' } }, t('draws')),
                    React.createElement("th", { style: { width: '15%' } }, t('prizes')),
                    React.createElement("th", { style: { width: '20%' } }, t('created_at')),
                    user.isManager() && React.createElement("th", null))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: user.isManager() ? 5 : 4 }),
                dataframe.getData().map(function (prizeScheme) { return React.createElement("tr", { key: prizeScheme.id },
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/prize-schemes/".concat(prizeScheme.id) },
                            React.createElement("strong", null, prizeScheme.title))),
                    React.createElement("td", null, formatNumber(prizeScheme.draws_count)),
                    React.createElement("td", null, formatNumber(prizeScheme.prizes_count)),
                    React.createElement("td", null,
                        React.createElement(DateTime, { date: prizeScheme.created_at })),
                    user.isManager() && React.createElement("td", { className: gs('text-right') },
                        React.createElement(Link, { to: "/prize-schemes/".concat(prizeScheme.id, "/edit"), className: gs('btn', 'btn-sm', 'btn-outline-secondary', { disabled: !prizeScheme.editable }) }, t('edit')),
                        ' ',
                        React.createElement("button", { type: "button", onClick: function () { return deleteModal.open(prizeScheme); }, disabled: !prizeScheme.deletable, className: gs('btn', 'btn-sm', 'btn-outline-danger') }, t('delete')))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })),
        deleteModal.isOpen && React.createElement(ConfirmationModal, { modal: deleteModal },
            React.createElement("h5", { className: gs('my-2') }, t('confirm_delete', { title: deleteModal.props.title }))));
};
export default PrizeSchemeOverview;
